import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
export function Bonos() {
  return <section className="w-full bg-paper-card py-20 md:py-28" aria-labelledby="bonos-title" data-id="element-13" data-mp="2hdmkrfecmm1b">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-14" data-mp="2ld3tqiszi1b8">
        <div className="max-w-2xl" data-id="element-15" data-mp="2q4v9rzeikon4">
          <p className="inline-flex items-center gap-2 rounded-full bg-signal-soft px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-signal" data-id="element-16" data-mp="2q5wyv7sd7bnu">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-17" data-mp="3032pkex2h0nj" />
            Sin cargo extra
          </p>
          <h2 id="bonos-title" className="mt-5 text-4xl font-extrabold tracking-tightest text-ink md:text-5xl" data-id="element-18" data-mp="3525tfw1b90tx">
            6 Bonos incluidos
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-19" data-mp="1ao4msozir9ja">
            Herramientas prácticas que resuelven los momentos más difíciles del consultorio.
          </p>
        </div>

        <ul className="mt-12 grid gap-x-16 border-t border-line md:grid-cols-2" data-id="element-20" data-mp="1erjdqaozxabi">
          {bonos.map(bono => <li key={bono.number} className="flex items-start gap-5 border-b border-line py-6" data-id="element-21" data-mp="39dkmeozjxl71">
              <span className="mt-0.5 w-7 shrink-0 text-sm font-bold tabular-nums text-ink-muted" data-id="element-22" data-mp="34ezkml4nitgh">
                {bono.number}
              </span>
              <div className="min-w-0 flex-1" data-id="element-23" data-mp="xhceckyvkfj">
                <h3 className="text-lg font-bold leading-snug tracking-tight text-ink" data-id="element-24" data-mp="w6a6h766kqj">
                  {bono.title}
                </h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink-muted" data-id="element-25" data-mp="3s1xydb1dznap">
                  {bono.description}
                </p>
              </div>
              <p className="shrink-0 pl-2 text-right text-xs font-bold uppercase tracking-wide" data-id="element-26" data-mp="3i4t8b04f77om">
                <span className="block text-ink-muted line-through" data-id="element-27" data-mp="2bqbti8x819v0">{bono.price}</span>
                <span className="mt-1 block text-signal" data-id="element-28" data-mp="26q66j61wcbj9">Gratis</span>
              </p>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col gap-2 rounded-2xl bg-ink px-6 py-6 text-center sm:flex-row sm:items-baseline sm:justify-center sm:gap-4 sm:text-left md:px-10" data-id="element-29" data-mp="yriblpyii0t5">
          <p className="text-base font-medium text-white/60" data-id="element-30" data-mp="orrgpn61hjsj">
            Valor total de los bonos: <span className="line-through" data-id="element-31" data-mp="tr4ev42d2daf">$50.000</span>
          </p>
          <p className="text-xl font-extrabold tracking-tight text-white md:text-2xl" data-id="element-32" data-mp="f316jo0uipig">
            GRATIS con tu Mega Pack
          </p>
        </div>
      </div>
    </section>;
}